import {IconDown, IconUp} from "../icons";
import {ButtonSecondary} from "./ButtonSecondary";
import React, {useState} from "react";
import styled from "styled-components";

const ButtonWithAccordionBox = styled.div`
    position: relative;
    width: 100%;
`

const ButtonCont = styled.div`

`

const AccordionButton = styled(ButtonSecondary)`

`

const IconUpPlace = styled.div`
    margin-left: 12px;
`

const Accordion = styled.div`
    margin-top: 15px;
    width: 100%;

    &[data-open="true"] {
        display: block;
    }

    &[data-open="false"] {
        display: none;
    }
`

const AccordionInner = styled.div`
    display: flex;
    width: 100%;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: flex-start;
    align-items: flex-end;
    gap: 12px;
`

export const ButtonWithAccordion = (
	{
		btnTitle = '',
		btnIcon = null,
		isOpenInit = false,
		children
	}) => {
	const [isOpen, setIsOpen] = useState(isOpenInit)
	const accordionBtnHandler = (event) => {
		event.preventDefault() //to prevent side effect - trigger of 'submit' action in FormGen
		setIsOpen((prevState) => !prevState)
	}

	return (
		<ButtonWithAccordionBox>
			<ButtonCont>
				<AccordionButton onClick={accordionBtnHandler}>
					{btnIcon}
					{btnTitle}
					<IconUpPlace data-open={isOpen}>
						{isOpen ? <IconUp/> : <IconDown/>}
					</IconUpPlace>
				</AccordionButton>
			</ButtonCont>

			<Accordion data-open={isOpen}>
				<AccordionInner>
					{children}
				</AccordionInner>
			</Accordion>
		</ButtonWithAccordionBox>
	)
}